import React, { useEffect, useRef, useState } from "react";

export const LazyImage = ({ className = "", ...props }) => {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (ref.current?.complete) setLoaded(true);
  }, []);

  return (
    <img
      ref={ref}
      loading="lazy"
      decoding="async"
      onLoad={() => setLoaded(true)}
      className={`${className} ${loaded ? "img-fade-in" : "opacity-0"}`}
      alt={props.alt || ""}
      {...props}
    />
  );
};
